import React, { useState } from 'react';
import CrossIcon from '../atoms/CrossIcon';
const FileSizePopup = ({ title, message, buttonLabel, handleReset }) => {
    const [handleDisplay, setHandleDisplay] = useState(true);
    const handlePopupDisplay = () => {
        handleReset();
        setHandleDisplay(false);
    };
    return (React.createElement(React.Fragment, null, handleDisplay && (React.createElement("div", { className: "th-c-warning" },
        React.createElement("div", { className: "th-c-warning__inner" },
            React.createElement("button", { className: "th-c-warning__close", "aria-label": "close", onClick: handlePopupDisplay },
                React.createElement(CrossIcon, null)),
            React.createElement("h2", { className: "th-c-warning__title" }, title),
            React.createElement("p", { className: "th-c-warning__message" }, message),
            React.createElement("div", { className: "th-c-warning__buttons" },
                React.createElement("button", { className: "button button--xl", style: { maxWidth: '170px' }, onClick: handlePopupDisplay }, buttonLabel)))))));
};
export default FileSizePopup;
